import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import LoyaltySpecialItem from './LoyaltySpecialItem';

// Ljubicasta je FIKSNA boja brojeva/trake/kvacice na summary kartici za SVE nivoe (po dizajnu -
// samo se ikonica menja po nivou, ne i ostatak kartice).
const SUMMARY_BRAND_COLOR = '#341275';
// Ime nivoa je po POZICIJI Condition-a u nizu, ne po anConditionId vrednosti.
// Imenovanje za 4+ nivo nije definisano dizajnom - "Joker {n}" je privremeni placeholder.
const TIER_NAMES = ['Deal', 'Super', 'Premium'];
// Slike "?" kartice po nivou - nisu sve iste: Deal ima odvojenu desktop (kvadratna, 188x189) i
// mobilnu (izduzena, 199x267) verziju; Super koristi JEDNU (izduzenu, 187x271) sliku i za desktop
// i za mobilni, prikazanu na "celu visinu" (aspect se poklapa sa stvarnom slikom, ne kroji se).
// aspect: null znaci "ostavi podrazumevanih 250x250 (kvadrat)" iz .special-flip-holder.
// alwaysOpen (Premium) - nema "?" korice/flip animacije uopste, kartica UVEK prikazuje pravi
// sadrzaj artikla (isto sto i "otvorene" kartice), samo na premium-joker.png pozadini umesto bele -
// i dalje funkcionalno zakljucana (nije klikabilna) pod istim uslovima kao i ostali nivoi.
// iconColor - boja kvadratica ikonice na summary kartici, prati boju STVARNE karte tog nivoa
// (deal-card.png je ljubicasta, super-card.png zlatna, premium-joker.png crna) - NIJE ista stvar
// kao SUMMARY_BRAND_COLOR (koja je fiksna za ostatak kartice).
const TIER_CARDS = [
    { desktopFile: 'deal-card.png', mobileFile: 'deal-card-mob.png', desktopAspect: null, mobileAspect: '199 / 267', openBg: null, alwaysOpen: false, iconColor: '#7c5cff', iconTextColor: '#fff', iconFile: 'deal-icon.png' },
    { desktopFile: 'super-card.png', mobileFile: 'super-card.png', desktopAspect: '146 / 234', mobileAspect: '146 / 234', minCardWidth: 140, maxCardWidth: 220, openBg: null, openBgColor: '#fff', alwaysOpen: false, iconColor: '#f0a500', iconTextColor: '#fff', iconFile: 'special-icon.png' },
    { desktopFile: null, mobileFile: null, desktopAspect: '274 / 420', mobileAspect: '274 / 420', cardWidth: 300, openBg: null, openBgColor: '#fff', alwaysOpen: true, iconColor: '#1a1a1a', iconTextColor: '#f0a500', iconFile: 'premium-icon.png', summaryIconFile: 'premium-summary-icon.png' },
];
// Obojeni panel oko "?" kartica (grid mod) - naslov + opisni tekst, statican po nivou (ne menja
// se po Prikazu). tone 'mystery' (Deal/Super, ljubicasta pozadina) vs 'premium' (crna pozadina) -
// vidi .joker-grid-panel-* u Loyalty.css. Deal-ov tekst nije bio u dizajnu (samo Super/Premium
// su bili prikazani) - izveden je po istom obrascu kao Super-ov, sa "Deal Joker" umesto "Super Joker".
// descKey - prevodivi tekst (sa ugradjenim <strong> markupom, vidi Trans u renderGridPanel)
// zivi u locales/*/loyalty.json, ne ovde direktno - ovaj niz je van komponente (nema pristup t()).
const TIER_PANEL = [
    { tone: 'mystery', descKey: 'dealJokerDesc' },
    { tone: 'mystery', descKey: 'superJokerDesc' },
    { tone: 'premium', descKey: 'premiumJokerDesc' },
];

const LoyaltySpecialConditionGroup = ({
    condition,
    colorIndex,
    getB2bSettings,
    handleCancelButtonClick,
    clickedSpecialItems,
    canceledItems,
    isCancelButtonClicked,
    setShouldAnimate,
    finishCart,
    shopIsActive,
    isShopActive,
    isLive,
    getUserInfo,
    loyaltySettings,
    confirmedPurchases,
    setEmptyValues,
    emptyValues,
    setFinishCartFunction,
    onItemClick,
    // 'both' (podrazumevano) = summary kartica + "?" kartice zajedno, kao pre. 'summary' = SAMO
    // summary kartica (za red ispod banera). 'grid' = SAMO "?" kartice (za blok ispod, na starom
    // mestu). Cela racunica stanja (isForcedLocked, allItemsSoldOut...) ostaje IDENTICNA za oba
    // poziva iste Condition-e (summary i grid) - samo se bira sta se od toga renderuje.
    mode = 'both',
}) => {
    const { t } = useTranslation('loyalty');
    const showSummary = mode === 'summary' || mode === 'both';
    const showGrid = mode === 'grid' || mode === 'both';
    // Lista je ugnjezdena po grupi pod istim imenom koje je ranije bilo ravno na vrhu odgovora.
    // Pre nego sto socket dostavi puna polja artikla (acBuyer, anPrice...), ovde stizu goli ID-jevi -
    // dovoljno za "?" placeholder kartice, isto kao sto je REST i ranije radio za nedostignut nivo.
    const items = condition.specialSlshopList || [];
    const tierName = TIER_NAMES[colorIndex] || `Joker ${colorIndex + 1}`;
    // Klasa po nivou (Deal/Super/Premium) - koristi se SAMO za CSS "order" na mobilnom (vidi
    // .joker-tier-* u Loyalty.css), da bi redosled kartica na mobilnom (Premium, Super, Deal) mogao
    // da se razlikuje od desktop redosleda, bez diranja DOM/render redosleda po nivou.
    const tierOrderClass = colorIndex === 0 ? 'joker-tier-deal' : colorIndex === 1 ? 'joker-tier-super' : colorIndex === 2 ? 'joker-tier-premium' : '';
    // Mobilna/desktop verzija "?" kartice - isti obrazac kao pozadina banera u LoyaltyCounterBlock.js
    // (CSS media-query image-swap ne radi u ovom projektu, bira se u JS-u).
    const [isMobileCard, setIsMobileCard] = useState(
        typeof window !== 'undefined' ? window.matchMedia('(max-width: 768px)').matches : false
    );
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const mql = window.matchMedia('(max-width: 768px)');
        const handleChange = (e) => setIsMobileCard(e.matches);
        mql.addEventListener('change', handleChange);
        return () => mql.removeEventListener('change', handleChange);
    }, []);
    // Slika "?" kartice po nivou - zamenjuje staru ravnu boju + "?" znak + EWE logo, jedna slika
    // vec nosi ceo izgled kartice. Fallback (4+ nivo, slike jos ne postoje) prati Deal-ov obrazac imena.
    const tierCard = TIER_CARDS[colorIndex] || { desktopFile: `${tierName.toLowerCase()}-card.png`, mobileFile: `${tierName.toLowerCase()}-card-mob.png`, desktopAspect: null, mobileAspect: null, openBg: null, alwaysOpen: false, iconColor: SUMMARY_BRAND_COLOR, iconTextColor: '#fff' };
    const cardImageFile = isMobileCard ? tierCard.mobileFile : tierCard.desktopFile;
    const cardImageUrl = cardImageFile ? `${process.env.PUBLIC_URL}/images/loyalty/${cardImageFile}` : null;
    const cardAspect = isMobileCard ? tierCard.mobileAspect : tierCard.desktopAspect;
    // Merimo STVARNU sirinu kontejnera - potrebno da znamo koliko kolona (max 4) realno stane PRI
    // MINIMALNOJ sirini kartice, a onda kartice RASTU do maksimalne sirine da popune red (manje
    // praznog prostora kad ih je 4, vise centriranog prostora kad ih je manje) - "nikad vise od 4
    // u redu, ali nikad ni nepotrebno uzano/prazno sa strane".
    const [holderEl, setHolderEl] = useState(null);
    const holderRef = useCallback((node) => setHolderEl(node), []);
    const [holderWidth, setHolderWidth] = useState(0);
    useEffect(() => {
        if (!cardAspect || typeof ResizeObserver === 'undefined' || !holderEl) return;
        const observer = new ResizeObserver((entries) => {
            setHolderWidth(entries[0].contentRect.width);
        });
        observer.observe(holderEl);
        return () => observer.disconnect();
    }, [cardAspect, holderEl]);
    const cardHolderStyle = (cardAspect && holderWidth > 0) ? (() => {
        const [rawW, rawH] = cardAspect.split('/').map(n => parseFloat(n.trim()));
        const gap = 16;
        const minCard = tierCard.minCardWidth || tierCard.cardWidth || 140;
        const maxCard = tierCard.maxCardWidth || tierCard.cardWidth || 220;
        let columns = Math.min(items.length, 4);
        while (columns > 1 && (columns * minCard + (columns - 1) * gap) > holderWidth) {
            columns--;
        }
        const w = Math.min(maxCard, (holderWidth - (columns - 1) * gap) / columns);
        const h = w * (rawH / rawW);
        return { width: `${w}px`, height: `${h}px`, paddingBottom: 0, flexShrink: 0 };
    })() : undefined;
    // Deal (CSS Grid put, bez cardAspect) - broj kolona prati STVARAN broj artikala (max 4). Kolone
    // su FIKSNE 234px (isto sto i .special-open-deal kartica), NE 1fr - 1fr bi napravio SIRE kolone
    // za manje artikala (npr. 2), a kartica je fiksne velicine, pa bi ostajala mala u prevelikoj
    // celiji (potvrdjeno uzivo - vidljiv razmak izmedju kartica umesto da su zbijene/centrirane).
    // justify-content:center (CSS) centrira red kad fiksne kolone ne popune celu sirinu panela.
    const dealGridStyle = !cardAspect ? { gridTemplateColumns: `repeat(${Math.max(1, Math.min(items.length, 4))}, 234px)` } : undefined;
    const openCardBgUrl = tierCard.openBg ? `${process.env.PUBLIC_URL}/images/loyalty/${tierCard.openBg}` : null;
    const openCardBgColor = tierCard.openBgColor || null;
    // true ako POSTOJI bilo koji kliknut kljuc u ovom Condition-u (mapa, ne pojedinacna vrednost -
    // klik u DRUGOM Condition-u ne sme da utice na ovaj) - zakljucava ceo Condition da se ne bi duplo kliknulo
    const isGroupPending = Object.keys(clickedSpecialItems).some(k => k.startsWith(`${condition.anConditionId}_`));
    // true ako u ovoj grupi postoji stavka koju je BAS ovaj korisnik lokalno otvorio/potvrdio, a NIJE
    // otkazana - koristi se da "zamrzne" natpis na PRIKAZ 2 dok on odlucuje, cak i kad server (canClick)
    // vec javi da je pravo iskorisceno (log se pise na sam klik, pre nego sto korisnik zavrsi ili otkaze).
    // Otkazivanje (canceledItems) namerno GASI ovo - nakon Odustani natpis treba da padne na "zatvoreno".
    const hasLocalOverride = items.some((_, key) => {
        const groupItemKey = `${condition.anConditionId}_${key}`;
        return !canceledItems[groupItemKey] && (!!clickedSpecialItems[groupItemKey] || !!confirmedPurchases[groupItemKey]);
    });
    // true ako su SVI artikli u grupi vec stvarno prodati (bilo kojoj kompaniji) - deljen fond, vise
    // kompanija bira iz istog seta, pa je moguce da canClick ostane true (JA jos nisam iskoristio pravo)
    // dok fizicki nema vise sta da se izabere (neko drugi je stigao pre mene do svakog artikla).
    // Zivo potvrdjeno na produkciji 2026-08-25 - canClick:1 sa svih 8 artikala vec imalo acBuyer.
    const allItemsSoldOut = items.every(item => item.acBuyer !== null);
    // isForcedLocked ima DVA nezavisna razloga za zakljucavanje (|| = dovoljan je JEDAN od njih):
    //   1) isShopActive == 0     -> ceo shop je van perioda (pre pocetka ili posle kraja datuma)
    //   2) !condition.isReached  -> BAS ovaj Condition jos nije dostignut
    // Treci nekadasnji razlog (!isLive, socket jos nije stigao) je izdvojen u posebnu "UCITAVANJE"
    // granu ispod - dok cekamo prvu socket poruku, jos ne znamo pouzdano stanje pa ne zelimo da
    // pogresno kazemo "nije dostignuto" ako je Condition u medjuvremenu vec dostignut.
    const isForcedLocked = isShopActive == 0 || !condition.isReached;
    const tierPanel = TIER_PANEL[colorIndex];

    if (!items.length) {
        return null;
    }

    // Joker summary kartica - zamenjuje staru "5 zvezdica + pasus" najavu iznad "?" kartica.
    // 'muted'/'warning' tonovi namerno gaze i ikonicu i SUMMARY_BRAND_COLOR (van perioda /
    // rasprodato su izuzeci, ne redovno stanje tog nivoa) - boja im dolazi iz CSS klase.
    const renderSummaryCard = ({ tone, icon, statusText, showCheck }) => {
        const achieved = condition.anBuyerTotalPrice ?? 0;
        const limit = condition.anConditionLimit ?? 0;
        const pct = limit > 0 ? Math.min(100, (achieved / limit) * 100) : 0;
        // Brojevi/traka/kvacica ostaju FIKSNO ljubicasti (SUMMARY_BRAND_COLOR) za sva tri nivoa, po dizajnu.
        const brandStyle = tone === 'brand' ? { backgroundColor: SUMMARY_BRAND_COLOR, color: '#fff' } : undefined;
        // 'muted' (van perioda / sve rasprodato) namerno ne prikazuje brojeve/traku - napredak
        // vise nije relevantan kad nema sta da se osvoji, samo status poruka ima smisla.
        const showProgress = tone !== 'muted';
        return (
            <div className={`joker-summary-card ${tone !== 'brand' ? `joker-summary-card-${tone}` : ''}`}>
                <div className="joker-summary-card-top">
                    <div className={`joker-summary-icon ${colorIndex === 0 ? 'joker-summary-icon-deal' : ''}`}>
                        {/* Ikonica nivoa (Premium ima posebnu za summary karticu, razlicitu od one u
                            grid panelu) SAMO dok trenutno moze da se klikne (crown) - u svim ostalim
                            stanjima (jos zakljucano, vec iskorisceno, rasprodato dok je bilo otvoreno)
                            ne moze da se klikne, pa ide zajednicka katanac ikonica za sva 3 nivoa. */}
                        <img
                            src={`${process.env.PUBLIC_URL}/images/loyalty/${icon === 'crown' ? (tierCard.summaryIconFile || tierCard.iconFile) : 'lock-summary-icon.png'}`}
                            alt=""
                            className="joker-summary-icon-img"
                        />
                    </div>
                    <div className="joker-summary-title">{tierName} <strong>JOKER</strong></div>
                </div>
                {showProgress && (
                    <>
                        <div className="joker-summary-numbers">
                            {/* Levi (ostvareno) broj je UVEK ljubicast, bez obzira na stanje - prati boju trake
                                (i ona je uvek ljubicasta u brand/warning tonu). Desni (limit) je sivo SAMO kad
                                nema check ikonice (showCheck) - tj. dok se jos broji ka pragu, jos nije
                                dostignuto - inace je i on ljubicast. */}
                            <span className="joker-summary-numbers-achieved" style={{ color: SUMMARY_BRAND_COLOR }}>{achieved.toFixed(2)}</span>
                            <span>&nbsp;/&nbsp;</span>
                            <span className="joker-summary-numbers-limit" style={showCheck ? { color: SUMMARY_BRAND_COLOR } : undefined}>{limit.toFixed(2)} EUR</span>
                            {showCheck && (
                                <span className="joker-summary-check-circle" style={brandStyle}>
                                    <i className="fas fa-check"></i>
                                </span>
                            )}
                        </div>
                        <div className="joker-summary-bar-track">
                            <div className="joker-summary-bar-fill" style={{ width: `${pct}%`, ...(tone === 'brand' ? { backgroundColor: SUMMARY_BRAND_COLOR } : {}) }}></div>
                        </div>
                    </>
                )}
                <div className="joker-summary-status">{statusText}</div>
            </div>
        );
    };

    // Obojeni panel oko "?" kartica (grid mod) - ikonica + naslov + opisni tekst (TIER_PANEL,
    // statican po nivou), pa kartice ispod. Isti panel se koristi u sva 4 Prikaza (samo se menja
    // sta je unutra - loading/locked/open/used kartice).
    const renderGridPanel = (cardsContent) => (
        <div className={`joker-grid-panel joker-grid-panel-${tierPanel ? tierPanel.tone : 'mystery'}`}>
            <div className="joker-grid-panel-header">
                <img
                    src={`${process.env.PUBLIC_URL}/images/loyalty/${tierCard.iconFile}`}
                    alt=""
                    className="joker-grid-panel-icon"
                />
                <div className="joker-grid-panel-title">{tierName} <strong>JOKER</strong></div>
            </div>
            {tierPanel && (
                <p className="joker-grid-panel-desc">
                    <Trans i18nKey={`loyalty:${tierPanel.descKey}`} components={{ strong: <strong /> }} />
                </p>
            )}
            {cardsContent}
        </div>
    );

    // PRIKAZ 1 (nije dostignut) i PRIKAZ 3 (iskorisceno/rasprodato) - prekriva CEO blok
    // (.col-sm-12.loyalty-special, naslov+opis+kartice) jednim overlay-om (crna, 30% providnost)
    // sa lock-icon.png po sredini, umesto da se zakljucanost/nedostupnost vidi samo kroz
    // pojedinacne "?" kartice. Renderuje se van renderGridPanel-a (kao sibling od
    // .loyalty-special-product-text-boxes), da bi stvarno pokrio CEO spoljasnji blok, ne samo
    // uzi .joker-grid-panel duboko unutra.
    const renderLockOverlay = () => (
        <div className="joker-grid-lock-overlay">
            <img src={`${process.env.PUBLIC_URL}/images/loyalty/lock-icon.png`} alt="" />
        </div>
    );

    // Premium (alwaysOpen) nema "?" koricu - kad LoyaltySpecialItem nema stvaran artikal da prikaze
    // (isItem kapija u LoyaltySpecialItem.js, item.anPrice jos nije popunjen - shop nije dostignut/
    // Condition nije otkljucan), kartica bi ostala PRAZNA (samo prazan .special-flip-holder). Ovo
    // popunjava tu prazninu placeholder slikom - MORA nestati cim stigne stvaran artikal (anPrice),
    // nikad se ne sme videti preko pravog proizvoda. Ide PRE LoyaltySpecialItem-a u markupu - kad oba
    // uslova (jer su medjusobno iskljuciva) ikad greskom budu tacna, LoyaltySpecialItem (kasnije u
    // DOM-u, isto position:absolute preko cardAspect-a) svakako iscrtava preko nje.
    const renderPremiumLockedBg = (resolvedItem) => {
        if (!tierCard.alwaysOpen || (resolvedItem && resolvedItem.anPrice)) {
            return null;
        }
        return (
            <div
                className="joker-premium-locked-bg"
                style={{ backgroundImage: `url(https://resource.ewe.rs/loyalty/loyalty-joker-premium-locked.png)` }}
            ></div>
        );
    };

    const renderLockedCards = () => (
        <div ref={holderRef} className={`${cardAspect ? '' : 'justify-content-center'} loyalty-special-product-holder ${cardAspect ? 'loyalty-special-product-holder-fixed' : ''} ${cardAspect && items.length === 1 ? 'loyalty-special-product-holder-single' : ''}`} style={dealGridStyle}>
            {items.map((item, key) => {
                // I dok je OVA kompanija zakljucana (nije dostigla prag), artikal koji je VEC
                // stvarno prodat nekoj DRUGOJ kompaniji treba da se vidi kao prodat - inace ova
                // kompanija pogresno pomisli da niko nista nije kupio iz cele grupe. Ne otkljucava
                // se za klik (i dalje pointerEvents:none), samo informativno "Kupio [ime]".
                const isSoldItem = item.acBuyer !== null;
                // Premium (alwaysOpen) nema "?" korice/flip uopste - kartica UVEK prikazuje pravi
                // sadrzaj (isto sto i otvorene kartice), samo na premium-joker.png pozadini, i dalje
                // nije klikabilna (pointerEvents:none ostaje na specialShopDiv-u kad on postoji).
                const showOpenContent = tierCard.alwaysOpen || isSoldItem;
                return (
                    <div className="special-flip-holder" key={key} style={cardHolderStyle}>
                        {renderPremiumLockedBg(item)}
                        {showOpenContent && (
                            <LoyaltySpecialItem
                                handleCancelButtonClick={handleCancelButtonClick}
                                clickedSpecialItems={clickedSpecialItems}
                                setShouldAnimate={setShouldAnimate}
                                finishCart={finishCart}
                                keyItem={key}
                                shopIsActive={shopIsActive}
                                getUserInfo={getUserInfo}
                                loyaltySettings={loyaltySettings}
                                isClickedSpecialItem={false}
                                item={item}
                                setEmptyValues={setEmptyValues}
                                emptyValues={emptyValues}
                                type={1}
                                start={loyaltySettings.adLoyaltyStartDate}
                                end={loyaltySettings.adLoyaltyEndDate}
                                isConditionReached={true}
                                setFinishCartFunction={setFinishCartFunction}
                                itemKey={`${condition.anConditionId}_${key}`}
                                cardBg={openCardBgUrl}
                                cardBgColor={openCardBgColor}
                                cardAspect={cardAspect}
                                soldOutSpecial={colorIndex === 1}
                                soldOutPremium={colorIndex === 2}
                                openCardDarkText={colorIndex === 1 || colorIndex === 2}
                                isDeal={colorIndex === 0}
                                tier={tierName}
                            />
                        )}
                        {!tierCard.alwaysOpen && (
                            <div
                                className={`specialShopDiv ${isSoldItem ? 'flip' : ''}`}
                                style={{ cursor: 'not-allowed', pointerEvents: 'none', width: '100%', height: '100%', backgroundImage: `url(${cardImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );

    // prazne poluprovidne sive kartice (bez "?" i loga) - propustaju pozadinu, nema tvrdnje o
    // dostignutosti praga, jer dok socket jos nije stigao ne znamo pouzdano stanje.
    const renderLoadingCards = () => (
        <div ref={holderRef} className={`${cardAspect ? '' : 'justify-content-center'} loyalty-special-product-holder ${cardAspect ? 'loyalty-special-product-holder-fixed' : ''} ${cardAspect && items.length === 1 ? 'loyalty-special-product-holder-single' : ''}`} style={dealGridStyle}>
            {items.map((_, key) => (
                <div className="special-flip-holder" key={key} style={cardHolderStyle}>
                    <div
                        className='specialShopDiv'
                        style={{ cursor: 'not-allowed', pointerEvents: 'none', backgroundColor: 'rgba(126, 105, 153, 0.1)', width: '100%', height: '100%' }}
                    ></div>
                </div>
            ))}
        </div>
    );

    // PRIKAZ 0 od 3 - UCITAVANJE: dok socket jos nije poslao nijednu poruku otkad je stranica
    // otvorena. Sive providne kartice, bez teksta o pragu (jos ne znamo pouzdano da li je dostignut).
    if (!isLive) {
        return (
            <>
                {showGrid && (
                    <div className="col-sm-12 loyalty-special">
                        <div className={`loyalty-special-product-text-boxes ${colorIndex === 0 ? 'joker-panel-deal' : ''} ${colorIndex === 1 ? 'joker-panel-super' : ''}`}>
                            <div className="joker-grid-panel-outer" style={{ maxWidth: '1016px', margin: '0 auto' }}>
                                {renderGridPanel(renderLoadingCards())}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }

    // PRIKAZ 1 od 3 - ZAKLJUCANO: prikazuje se ako je isForcedLocked true (shop van perioda,
    // ili Condition nije dostignut). Samo "?" kartice, nista klikabilno.
    if (isForcedLocked) {
        const remaining = Math.max(0, (condition.anConditionLimit ?? 0) - (condition.anBuyerTotalPrice ?? 0));
        return (
            <>
                {showSummary && (
                    <div className={`joker-summary-slot ${tierOrderClass}`}>
                        {/* isShopActive==0 (shop van perioda) NAMERNO se vise ne razlikuje od
                            redovnog "nije dostignut" prikaza - summary kartica uvek prikazuje
                            brojeve/traku (progress), bez obzira da li je shop trenutno aktivan.
                            allItemsSoldOut ostaje jedini "muted" (bez progresa) slucaj. */}
                        {allItemsSoldOut ? (
                            renderSummaryCard({
                                tone: 'muted',
                                icon: 'lock',
                                statusText: t('svidArtikliIskorisceni'),
                            })
                        ) : (
                            renderSummaryCard({
                                tone: 'brand',
                                icon: 'lock',
                                statusText: <Trans i18nKey="loyalty:josDoOtkljucavanja" values={{ remaining: remaining.toFixed(2) }} components={{ strong: <strong /> }} />,
                            })
                        )}
                    </div>
                )}
                {showGrid && (
                    <div className="col-sm-12 loyalty-special">
                        <div className={`loyalty-special-product-text-boxes ${colorIndex === 0 ? 'joker-panel-deal' : ''} ${colorIndex === 1 ? 'joker-panel-super' : ''}`}>
                            <div className="joker-grid-panel-outer" style={{ maxWidth: '1016px', margin: '0 auto' }}>
                                {renderGridPanel(renderLockedCards())}
                            </div>
                            {renderLockOverlay()}
                        </div>
                    </div>
                )}
            </>
        );
    }

    // PRIKAZ 2 od 3 - OTVORENO: prikazuje se ako je Condition dostignut I jos uvek dostupan
    // za klik (canClick truthy) I ima jos bar jedan neprodat artikal (!allItemsSoldOut) - deljen fond
    // izmedju kompanija, canClick moze ostati true i kad je fond vec prazan (neko drugi stigao pre mene).
    // ILI ako BAS ovaj korisnik ima lokalno otvorenu/potvrdjenu stavku koju jos nije otkazao
    // (hasLocalOverride) - ovo ima prioritet nad allItemsSoldOut, da natpis ne "iskoci" na zatvoreno
    // dok on odlucuje, vec ostane "Cestitamo" sve dok on licno ne otkaze (tada pada na PRIKAZ 3).
    // Kartice su klikabilne, klik salje zahtev za kupovinu.
    if (hasLocalOverride || (condition.canClick && !allItemsSoldOut)) {
        return (
            <>
                {showSummary && (
                    <div className={`joker-summary-slot ${tierOrderClass}`}>
                        {renderSummaryCard({
                            tone: 'brand',
                            icon: 'crown',
                            showCheck: true,
                            statusText: <Trans i18nKey="loyalty:otkljucaliSteNivo" values={{ tierName }} components={{ strong: <strong /> }} />,
                        })}
                    </div>
                )}
                {showGrid && (
                    <div className="col-sm-12 loyalty-special">
                        <div className={`loyalty-special-product-text-boxes ${colorIndex === 0 ? 'joker-panel-deal' : ''} ${colorIndex === 1 ? 'joker-panel-super' : ''}`}>
                            <div className="joker-grid-panel-outer" style={{ maxWidth: '1016px', margin: '0 auto' }}>
                                {renderGridPanel(
                                <div ref={holderRef} className={`${cardAspect ? '' : 'justify-content-center'} loyalty-special-product-holder ${cardAspect ? 'loyalty-special-product-holder-fixed' : ''} ${cardAspect && items.length === 1 ? 'loyalty-special-product-holder-single' : ''}`} style={dealGridStyle}>
                                    {items.map((item, key) => {
                                        const groupItemKey = `${condition.anConditionId}_${key}`;
                                        // console.log('[DEBUG canClick:1] item oblik za', groupItemKey, ':', item);
                                        const confirmedItem = confirmedPurchases[groupItemKey];
                                        // kartica se "otvara" (prikazuje pravi sadrzaj umesto "?") ako: artikal je vec STVARNO
                                        // nekome prodat (uvek prikazi, cinjenica sa servera) - ILI (kliknuta/potvrdjena I NIJE
                                        // upravo otkazana). Otkazivanje vraca IZGLED na "?" ali ne otkljucava ceo Condition
                                        // (to radi clickedSpecialItems, namerno se ne dira pri otkazivanju).
                                        const isItemOpen = item.acBuyer !== null || (!canceledItems[groupItemKey] && (!!clickedSpecialItems[groupItemKey] || !!confirmedItem));
                                        const cardEl = (
                                            <div className="special-flip-holder" style={cardHolderStyle}>
                                                {renderPremiumLockedBg(confirmedItem ? confirmedItem : item)}
                                                {(tierCard.alwaysOpen || isItemOpen) && (
                                                    <LoyaltySpecialItem
                                                        handleCancelButtonClick={handleCancelButtonClick}
                                                        clickedSpecialItems={clickedSpecialItems}
                                                        setShouldAnimate={setShouldAnimate}
                                                        finishCart={finishCart}
                                                        keyItem={key}
                                                        shopIsActive={shopIsActive}
                                                        getUserInfo={getUserInfo}
                                                        loyaltySettings={loyaltySettings}
                                                        isClickedSpecialItem={!!confirmedItem}
                                                        item={confirmedItem ? confirmedItem : item}
                                                        setEmptyValues={setEmptyValues}
                                                        emptyValues={emptyValues}
                                                        type={1}
                                                        start={loyaltySettings.adLoyaltyStartDate}
                                                        end={loyaltySettings.adLoyaltyEndDate}
                                                        isConditionReached={condition.isReached}
                                                        setFinishCartFunction={setFinishCartFunction}
                                                        itemKey={groupItemKey}
                                                        cardBg={openCardBgUrl}
                                                        cardBgColor={openCardBgColor}
                                                        cardAspect={cardAspect}
                                                        soldOutSpecial={colorIndex === 1}
                                                        soldOutPremium={colorIndex === 2}
                                                        openCardDarkText={colorIndex === 1 || colorIndex === 2}
                                                        isDeal={colorIndex === 0}
                                                        tier={tierName}
                                                    />
                                                )}
                                                {/* Deal/Super: klik na CELU karticu (specialShopDiv preko cele kartice), flip
                                            animacija otkriva sadrzaj ispod. Premium (alwaysOpen): kartica VISE NIJE
                                            klik-cilj (pointerEvents:none), i nema vise dekorativnu "?" oznaku (dugme
                                            "Klikni" ispod kartice je sad jedini indikator/klik-cilj). */}
                                                <div
                                                    className={`specialShopDiv ${!tierCard.alwaysOpen && isItemOpen ? 'flip' + (isCancelButtonClicked === groupItemKey ? ' flip-reverse' : '') : ''}`}
                                                    style={{
                                                        cursor: tierCard.alwaysOpen ? 'default' : (isGroupPending ? 'not-allowed' : 'pointer'),
                                                        pointerEvents: tierCard.alwaysOpen ? 'none' : (isGroupPending ? 'none' : 'auto'),
                                                        width: '100%',
                                                        height: '100%',
                                                        ...(tierCard.alwaysOpen
                                                            ? { display: 'flex', alignItems: 'center', justifyContent: 'center' }
                                                            : { backgroundImage: `url(${cardImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }),
                                                    }}
                                                    onClick={tierCard.alwaysOpen ? undefined : () => onItemClick(item._id, loyaltySettings.anLoyaltyTypeId, condition.anConditionId, groupItemKey)}
                                                >
                                                </div>
                                            </div>
                                        );
                                        if (!tierCard.alwaysOpen) {
                                            return <React.Fragment key={key}>{cardEl}</React.Fragment>;
                                        }
                                        return (
                                            <div className="special-flip-holder-group" key={key}>
                                                {cardEl}
                                                {!isItemOpen && (
                                                    <button
                                                        type="button"
                                                        className="special-select-button"
                                                        onClick={() => onItemClick(item._id, loyaltySettings.anLoyaltyTypeId, condition.anConditionId, groupItemKey)}
                                                    >
                                                        {t('klikni')}
                                                    </button>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }

    // PRIKAZ 3 od 3 - ISKORISCENO/RASPRODATO: sve sto ostane ako gornja dva if-a nisu tacna, tj.
    // Condition je dostignut (isForcedLocked je false) ali VISE nije dostupan za klik - iz DVA moguca
    // razloga: (a) canClick je 0/false, ovaj korisnik je vec iskoristio svoje pravo, ILI (b) canClick
    // je i dalje true ali je allItemsSoldOut true - pravo je jos neiskorisceno, ali je ceo deljeni fond
    // artikala vec prodat drugim kompanijama pre nego sto je ovaj korisnik stigao da bira (potvrdjeno
    // na produkciji 2026-08-25). Tekst ispod namerno pominje oba razloga. Kartice se prikazuju
    // samo informativno, nista klikabilno.
    // Isti razlog kao u komentaru iznad - canClick ostaje true kad je fond vec prazan, ali korisnik
    // jos nije klik(nuo)/potvrdio - razlikujemo tu poruku od "vec ste iskoristili svoje pravo".
    const isSoldOutWhileOpen = !!condition.canClick && allItemsSoldOut;
    return (
        <>
            {showSummary && (
                <div className={`joker-summary-slot ${tierOrderClass}`}>
                    {isSoldOutWhileOpen ? (
                        renderSummaryCard({
                            tone: 'warning',
                            icon: 'exclamation-triangle',
                            showCheck: true,
                            statusText: <Trans i18nKey="loyalty:ostvarilistePravoNa" values={{ tierName }} components={{ strong: <strong /> }} />,
                        })
                    ) : (
                        renderSummaryCard({
                            tone: 'brand',
                            icon: 'check',
                            showCheck: true,
                            statusText: <Trans i18nKey="loyalty:iskoristilistePonudu" values={{ tierName }} components={{ strong: <strong /> }} />,
                        })
                    )}
                </div>
            )}
            {showGrid && (
                <div className="col-sm-12 loyalty-special">
                    <div className={`loyalty-special-product-text-boxes ${colorIndex === 0 ? 'joker-panel-deal' : ''} ${colorIndex === 1 ? 'joker-panel-super' : ''}`}>
                        <div className="joker-grid-panel-outer" style={{ maxWidth: '1016px', margin: '0 auto' }}>
                            {renderGridPanel(
                            <div ref={holderRef} className={`${cardAspect ? '' : 'justify-content-center'} loyalty-special-product-holder ${cardAspect ? 'loyalty-special-product-holder-fixed' : ''} ${cardAspect && items.length === 1 ? 'loyalty-special-product-holder-single' : ''}`} style={dealGridStyle}>
                                {items.map((item, key) => {
                                    const groupItemKey = `${condition.anConditionId}_${key}`;
                                    const confirmedItem = confirmedPurchases[groupItemKey];
                                    // Isti prioritet kao u PRIKAZU 2: po specifikaciji tiketa i potvrdi backend
                                    // tima, postCompanyLoyalityShopSpecialLog upisuje log NA SAM KLIK (pa canClick
                                    // treba da padne na 0) - acBuyer se upisuje tek kasnije, kad korisnik zavrsi
                                    // kroz "Dodaj u korpu". Tacan tajming (koliko brzo frontend sazna za to preko
                                    // socket-a) nije live-testiran u ovoj sesiji. Bez ovog local-state prioriteta,
                                    // BAS korisnik koji je upravo kliknuo bi u tom razmaku izgubio sopstvenu karticu
                                    // (i dugmad Odustani/Dodaj u korpu) jer bi item.acBuyer jos uvek bio null.
                                    const isItemOpen = item.acBuyer !== null || (!canceledItems[groupItemKey] && (!!clickedSpecialItems[groupItemKey] || !!confirmedItem));
                                    return (
                                        <div className="special-flip-holder" key={key} style={cardHolderStyle}>
                                            {renderPremiumLockedBg(confirmedItem ? confirmedItem : item)}
                                            {(tierCard.alwaysOpen || isItemOpen) && (
                                                <LoyaltySpecialItem
                                                    handleCancelButtonClick={handleCancelButtonClick}
                                                    clickedSpecialItems={clickedSpecialItems}
                                                    setShouldAnimate={setShouldAnimate}
                                                    finishCart={finishCart}
                                                    keyItem={key}
                                                    shopIsActive={shopIsActive}
                                                    getUserInfo={getUserInfo}
                                                    loyaltySettings={loyaltySettings}
                                                    isClickedSpecialItem={!!confirmedItem}
                                                    item={confirmedItem ? confirmedItem : item}
                                                    setEmptyValues={setEmptyValues}
                                                    emptyValues={emptyValues}
                                                    type={1}
                                                    start={loyaltySettings.adLoyaltyStartDate}
                                                    end={loyaltySettings.adLoyaltyEndDate}
                                                    isConditionReached={condition.isReached}
                                                    setFinishCartFunction={setFinishCartFunction}
                                                    itemKey={groupItemKey}
                                                    cardBg={openCardBgUrl}
                                                    cardBgColor={openCardBgColor}
                                                    cardAspect={cardAspect}
                                                    soldOutSpecial={colorIndex === 1}
                                                    soldOutPremium={colorIndex === 2}
                                                    openCardDarkText={colorIndex === 1 || colorIndex === 2}
                                                    isDeal={colorIndex === 0}
                                                    tier={tierName}
                                                />
                                            )}
                                            {!tierCard.alwaysOpen && (
                                                <div
                                                    className={`specialShopDiv ${isItemOpen ? 'flip' : ''}`}
                                                    style={{ cursor: 'not-allowed', pointerEvents: 'none', width: '100%', height: '100%', backgroundImage: `url(${cardImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                                                >
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                            )}
                            {renderLockOverlay()}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LoyaltySpecialConditionGroup;
